module.exports = __webpack_public_path__ + "static/media/bg.add13059.png";